import { Link } from 'react-router-dom'

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%20wallpaper%2C%20beautiful%20dreamy%20atmosphere%20with%20cherry%20blossoms%20and%20soft%20pastel%20colors%2C%20young%20characters%20in%20modern%20casual%20clothing%2C%20warm%20peach%20and%20cream%20tones%2C%20clean%20simple%20composition%2C%20gentle%20gradient%20background%2C%20romantic%20feel%2C%20storybook%20illustration%20quality&width=1800&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="韩漫画网 - 免费在线观看韩国漫画"
        title="韩漫画网 - 好看的韩漫大全"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="px-4 md:px-6 w-full max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-6xl lg:text-[72px] font-heading text-background-50 leading-tight">
              发现属于你的<br />精彩漫画世界
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200/90 max-w-lg leading-relaxed">
              韩漫画网 — 免费在线观看韩国漫画，覆盖恋爱、奇幻、动作、悬疑等热门分类。每日更新，追番不等待。
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3 mt-8 md:mt-10">
              <Link
                to="/category/love"
                className="px-7 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                立即探索
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 border border-background-300/60 text-background-50 text-sm font-medium rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-primary-500"></span>
        <span className="w-2 h-2 rounded-full bg-background-300/40"></span>
        <span className="w-2 h-2 rounded-full bg-background-300/40"></span>
      </div>
    </section>
  )
}